// ======================================== // FICHIER DATA - Configuration des cheveux
// ========================================

// COUPES GARÇONS avec settings indépendants par couleur
const HAIR_STYLES_BOY = [
    // 1. En piqué
    { 
        id: 'pique', 
        name: 'En piqué',
        icon_url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/pique.png?v=1772571832',
        colors: { 
            blond: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/En_pique_blond.png?v=1772924397',
                settings: { top: -34.1, left: -2.1, scale: 98 }
            },
            brun: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/En_pique_brun.png?v=1772924430',
                settings: { top: -34.1, left: -2.1, scale: 98 }
            },
            noir: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/En_pique_noir.png?v=1772924382',
                settings: { top: -34.1, left: -2.1, scale: 98 }
            },
            roux: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/En_pique_roux.png?v=1772924368',
                settings: { top: -34.1, left: -2.1, scale: 98 }
            },
            rose: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/En_pique_rose.png?v=1772924471',
                settings: { top: -34.1, left: -2.1, scale: 98 }
            },
            bleu: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/En_pique_bleu.png?v=1772924446',
                settings: { top: -34.1, left: -2.1, scale: 98 }
            },
            violet: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/En_pique_violet.png?v=1772924410',
                settings: { top: -34.1, left: -2.1, scale: 98 }
            }
        }
    },
    
    // 2. Buzz cut
    { 
        id: 'buzz', 
        name: 'Buzz cut',
        icon_url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/buzz_cut_illustration.png?v=1772571622',
        colors: { 
            blond: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Buzz_blond.png?v=1772923801',
                settings: { top: -32.3, left: -2.0, scale: 98 }
            },
            brun: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Buzz_brun.png?v=1772923788',
                settings: { top: -32.3, left: -2.0, scale: 98 }
            },
            noir: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Buzz_noir.png?v=1772923702',
                settings: { top: -32.3, left: -2.0, scale: 98 }
            },
            roux: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Buzz_roux.png?v=1772923677',
                settings: { top: -32.3, left: -2.0, scale: 98 }
            },
            rose: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Buzz_rose.png?v=1772923689',
                settings: { top: -32.3, left: -2.0, scale: 98 }
            },
            bleu: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Buzz_bleu.png?v=1772923665',
                settings: { top: -32.3, left: -2.0, scale: 98 }
            },
            violet: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Buzz_violet.png?v=1772923815',
                settings: { top: -32.3, left: -2.0, scale: 98 }
            }
        }
    },
    
    // 3. Sur le côté
    { 
        id: 'cote', 
        name: 'Sur le côté',
        icon_url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/cote.png?v=1772571669',
        colors: { 
            blond: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/sur_le_cote_blond.png?v=1772903549',
                settings: { top: -33.5, left: -1.2, scale: 99 }
            },
            brun: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/sur_le_cote_marron.png?v=1772903532',
                settings: { top: -33.5, left: -1.2, scale: 99 }
            },
            noir: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/sur_le_cote_noir.png?v=1772903565',
                settings: { top: -33.5, left: -1.2, scale: 99 }
            },
            roux: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/sur_le_cote_roux.png?v=1772903577',
                settings: { top: -33.5, left: -1.2, scale: 99 }
            },
            rose: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/sur_le_cote_rose.png?v=1772903590',
                settings: { top: -33.5, left: -1.2, scale: 99 }
            },
            bleu: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/sur_le_cote_bleu.png?v=1772903618',
                settings: { top: -33.5, left: -1.2, scale: 99 }
            },
            violet: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/sur_le_cote_violet.png?v=1772903604',
                settings: { top: -33.5, left: -1.2, scale: 99 }
            }
        }
    },
    
    // 4. Attaché
    { 
        id: 'attache', 
        name: 'Attaché',
        icon_url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/attache.png?v=1772571782',
        colors: { 
            blond: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/attache_blond.png?v=1772793654',
                settings: { top: -35.4, left: -0.1, scale: 98 }
            },
            brun: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/attache_brun.png?v=1772793823',
                settings: { top: -35.4, left: -0.1, scale: 98 }
            },
            noir: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/attache_noir.png?v=1772793677',
                settings: { top: -35.4, left: -0.1, scale: 98 }
            },
            roux: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/attache_roux.png?v=1772793705',
                settings: { top: -35.4, left: -0.1, scale: 98 }
            },
            rose: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/attache_rose.png?v=1772793690',
                settings: { top: -35.4, left: -0.1, scale: 98 }
            },
            bleu: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/attache_bleu.png?v=1772899774',
                settings: { top: -35.4, left: -0.1, scale: 98 }
            },
            violet: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/attache_violet.png?v=1772895629',
                settings: { top: -35.4, left: -0.1, scale: 98 }
            }
        }
    },
    
    // 5. Frange
    { 
        id: 'frange', 
        name: 'Frange',
        icon_url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/frange.png?v=1772571759',
        colors: { 
            blond: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Frange_blond.png?v=1772925122',
                settings: { top: -34.6, left: -1.5, scale: 98 }
            },
            brun: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Frange_brun.png?v=1772925085',
                settings: { top: -34.6, left: -1.5, scale: 98 }
            },
            noir: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Frange_noir.png?v=1772925061',
                settings: { top: -34.6, left: -1.5, scale: 98 }
            },
            roux: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Frange_roux.png?v=1772925097',
                settings: { top: -34.6, left: -1.5, scale: 98 }
            },
            rose: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Frange_rose.png?v=1772925073',
                settings: { top: -34.6, left: -1.5, scale: 98 }
            },
            bleu: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Frange_bleu.png?v=1772925110',
                settings: { top: -34.6, left: -1.5, scale: 98 }
            },
            violet: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Frange_violet.png?v=1772925133',
                settings: { top: -34.6, left: -1.5, scale: 98 }
            }
        }
    },
    
    // 6. Raie côté
    { 
        id: 'raie', 
        name: 'Raie côté',
        icon_url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/raie.png?v=1772571865',
        colors: { 
            blond: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Raie_sur_le_cote_blond.png?v=1772904437',
                settings: { top: -32.6, left: -0.5, scale: 98 }
            },
            brun: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Raie_sur_le_cote_brun.png?v=1772904597',
                settings: { top: -32.6, left: -0.5, scale: 98 }
            },
            noir: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Raie_sur_le_cote_noir.png?v=1772904400',
                settings: { top: -32.6, left: -0.5, scale: 98 }
            },
            roux: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Raie_sur_le_cote_roux.png?v=1772904558',
                settings: { top: -32.6, left: -0.5, scale: 98 }
            },
            rose: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Raie_sur_le_cote_rose.png?v=1772904424',
                settings: { top: -32.6, left: -0.5, scale: 98 }
            },
            bleu: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Raie_sur_le_cote_bleu.png?v=1772904617',
                settings: { top: -32.6, left: -0.5, scale: 98 }
            },
            violet: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Raie_sur_le_cote_violet.png?v=1772904412',
                settings: { top: -32.6, left: -0.5, scale: 98 }
            }
        }
    },
    
    // 7. Locks
    { 
        id: 'locks', 
        name: 'Locks',
        icon_url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/locks.png?v=1772571917',
        colors: { 
            blond: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Locks_blond.png?v=1772927554',
                settings: { top: -32.7, left: -1.4, scale: 98 }
            },
            brun: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Locks_brun.png?v=1772927406',
                settings: { top: -32.7, left: -1.4, scale: 98 }
            },
            noir: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Locks_noir.png?v=1772927392',
                settings: { top: -32.7, left: -1.4, scale: 98 }
            },
            roux: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Locks_roux.png?v=1772927653',
                settings: { top: -32.7, left: -1.4, scale: 98 }
            },
            rose: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Locks_rose.png?v=1772927457',
                settings: { top: -32.7, left: -1.4, scale: 98 }
            },
            bleu: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Locks_bleu.png?v=1772927573',
                settings: { top: -32.7, left: -1.4, scale: 98 }
            },
            violet: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Locks_violet.png?v=1772927421',
                settings: { top: -32.7, left: -1.4, scale: 98 }
            }
        }
    },
    
    // 8. Bouclé
    { 
        id: 'boucle', 
        name: 'Bouclé',
        icon_url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/boucle.png?v=1772571896',
        colors: { 
            blond: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_blond.png?v=1772925712',
                settings: { top: -34.2, left: 0.1, scale: 98 }
            },
            brun: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_brun.png?v=1772925659',
                settings: { top: -34.2, left: 0.1, scale: 98 }
            },
            noir: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_noir.png?v=1772925673',
                settings: { top: -34.2, left: 0.1, scale: 98 }
            },
            roux: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_roux.png?v=1772925698',
                settings: { top: -34.2, left: 0.1, scale: 98 }
            },
            rose: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_rose.png?v=1772925742',
                settings: { top: -34.2, left: 0.1, scale: 98 }
            },
            bleu: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_bleu.png?v=1772925728',
                settings: { top: -33.6, left: 0.2, scale: 97 }
            },
            violet: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_violet.png?v=1772925685',
                settings: { top: -34.2, left: 0.1, scale: 98 }
            }
        }
    },
    
    // 9. Côté volume
    { 
        id: 'cote_volume', 
        name: 'Côté volume',
        icon_url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/cote_volume.png?v=1772571952',
        colors: { 
            blond: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/cote_volume_blond.png?v=1772902666',
                settings: { top: -35.8, left: -0.6, scale: 98 }
            },
            brun: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/cote_volume_brun.png?v=1772902692',
                settings: { top: -35.8, left: -0.6, scale: 98 }
            },
            noir: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/cote_volume_noir.png?v=1772902652',
                settings: { top: -35.8, left: -0.6, scale: 98 }
            },
            roux: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/cote_volume_roux.png?v=1772902719',
                settings: { top: -35.8, left: -0.6, scale: 98 }
            },
            rose: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/cote_volume_rose.png?v=1772902679',
                settings: { top: -35.8, left: -0.6, scale: 98 }
            },
            bleu: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/cote_volume_bleu.png?v=1772902639',
                settings: { top: -35.8, left: -0.6, scale: 98 }
            },
            violet: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/cote_volume_violet.png?v=1772902707',
                settings: { top: -35.8, left: -0.6, scale: 98 }
            }
        }
    },
    
    // 10. Afro
    { 
        id: 'afro', 
        name: 'Afro',
        icon_url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/affro.png?v=1772571805',
        colors: { 
            blond: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Affro_blond.png?v=1772895242',
                settings: { top: -38.3, left: -4.1, scale: 100 }
            },
            brun: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Affro_brun.png?v=1772895214',
                settings: { top: -38.3, left: -4.1, scale: 100 }
            },
            noir: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Affro_noir.png?v=1772895201',
                settings: { top: -38.3, left: -4.1, scale: 100 }
            },
            roux: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Affro_roux.png?v=1772895256',
                settings: { top: -38.3, left: -4.1, scale: 100 }
            },
            rose: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Affro_rose.png?v=1772895228',
                settings: { top: -38.3, left: -4.1, scale: 100 }
            },
            bleu: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Affro_bleu.png?v=1772899787',
                settings: { top: -38.3, left: -4.1, scale: 100 }
            },
            violet: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Affro_Violet.png?v=1772895269',
                settings: { top: -38.3, left: -4.1, scale: 100 }
            }
        }
    },
    
    // 11. Long
    { 
        id: 'long', 
        name: 'Long',
        icon_url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/long.png?v=1772571969',
        colors: { 
            blond: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Long_blond.png?v=1772904979',
                settings: { top: -28.5, left: -3.8, scale: 102 }
            },
            brun: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Long_brun.png?v=1772905046',
                settings: { top: -28.5, left: -3.8, scale: 102 }
            },
            noir: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Long_noir.png?v=1772905074',
                settings: { top: -28.5, left: -3.8, scale: 102 }
            },
            roux: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Long_roux.png?v=1772905137',
                settings: { top: -28.5, left: -3.8, scale: 102 }
            },
            rose: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Long_rose.png?v=1772905151',
                settings: { top: -28.5, left: -3.8, scale: 102 }
            },
            bleu: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Long_bleu.png?v=1772905061',
                settings: { top: -28.5, left: -3.8, scale: 102 }
            },
            violet: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Long_violet.png?v=1772904993',
                settings: { top: -28.5, left: -3.8, scale: 102 }
            }
        }
    },
    
    // 12. Côté 2
    { 
        id: 'cote2', 
        name: 'Côté 2',
        icon_url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/cote_2.png?v=1772571732',
        colors: { 
            blond: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Cote_2_blond.png?v=1772927145',
                settings: { top: -32.3, left: 0.6, scale: 99 }
            },
            brun: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Cote_2_brun.png?v=1772927132',
                settings: { top: -32.3, left: 0.6, scale: 99 }
            },
            noir: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Cote_2_noir.png?v=1772927170',
                settings: { top: -32.3, left: 0.6, scale: 99 }
            },
            roux: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Cote_2_roux.png?v=1772926981',
                settings: { top: -32.3, left: 0.6, scale: 99 }
            },
            rose: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Cote_2_rose.png?v=1772927045',
                settings: { top: -32.3, left: 0.6, scale: 99 }
            },
            bleu: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Cote_2_bleu.png?v=1772927033',
                settings: { top: -32.3, left: 0.6, scale: 99 }
            },
            violet: {
                url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Cote_2_violet.png?v=1772927157',
                settings: { top: -32.3, left: 0.6, scale: 99 }
            }
        }
    }
];

const HAIR_STYLES_GIRL = [
    // 1. Coupe carré
    { 
        id: 'carre', 
        name: 'Coupe carré',
        icon_url: '',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Carre_Fille_blonde.png?v=1774902594', settings: { top: -28.3, left: -7.4, scale: 102 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Carre_Fille_brun.png?v=1774902625', settings: { top: -28.3, left: -7.4, scale: 102 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Carre_Fille_noir.png?v=1774902984', settings: { top: -28.3, left: -7.4, scale: 102 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Carre_Fille_roux.png?v=1774902610', settings: { top: -28.3, left: -7.4, scale: 102 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Carre_Fille_rose.png?v=1774901905', settings: { top: -28.3, left: -7.4, scale: 102 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Carre_Fille_bleu.png?v=1774902560', settings: { top: -28.3, left: -7.4, scale: 102 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Carre_Fille_violet.png?v=1774902578', settings: { top: -28.3, left: -7.4, scale: 102 }}
        }
    },
    
    // 2. Bouclé long
    { 
        id: 'boucle_long', 
        name: 'Bouclé long',
        icon_url: '',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_long_blonde.png?v=1774902512', settings: { top: -17, left: -1.5, scale: 104 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_long_brun.png?v=1774902471', settings: { top: -17, left: -1.5, scale: 104 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_long_noir.png?v=1774902402', settings: { top: -17, left: -1.5, scale: 104 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_long_roux.png?v=1774902531', settings: { top: -17, left: -1.5, scale: 104 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_long_rose.png?v=1774902452', settings: { top: -17, left: -1.5, scale: 104 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_long_bleu.png?v=1774902493', settings: { top: -17, left: -1.5, scale: 104 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Boucle_long_violet.png?v=1774902428', settings: { top: -17, left: -1.5, scale: 104 }}
        }
    },
    
    // 3. Lisse long
    { 
        id: 'lisse_long', 
        name: 'Lisse long',
        icon_url: '',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Lisse_long_blonde.png?v=1774903332', settings: { top: -15.7, left: -1.8, scale: 103 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Lisse_long_brun.png?v=1774903352', settings: { top: -15.7, left: -1.8, scale: 103 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Lisse_long_noir.png?v=1774903260', settings: { top: -15.7, left: -1.8, scale: 103 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Lisse_long_roux.png?v=1774903277', settings: { top: -15.7, left: -1.8, scale: 103 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Lisse_long_rose.png?v=1774903311', settings: { top: -15.7, left: -1.8, scale: 103 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Lisse_long_bleu.png?v=1774903245', settings: { top: -15.7, left: -1.8, scale: 103 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Lisse_long_violet.png?v=1774903293', settings: { top: -15.7, left: -1.8, scale: 103 }}
        }
    },
    
    // 4. Cheveux attachés
    { 
        id: 'attache', 
        name: 'Cheveux attachés',
        icon_url: '',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Attache_blonde.png?v=1774902272', settings: { top: -26.7, left: 9, scale: 106 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Attache_brun-fille.png?v=1774904849', settings: { top: -26.7, left: 9, scale: 106 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Attache_noir-fill.png?v=1774904879', settings: { top: -26.7, left: 9, scale: 106 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Attache_roux-fille.png?v=1774904910', settings: { top: -26.7, left: 9, scale: 106 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Attache_rose-fille.png?v=1774904896', settings: { top: -26.7, left: 9, scale: 106 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Attache_bleu-fille.png?v=1774904970', settings: { top: -26.7, left: 9, scale: 106 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Attache_violet-fille.png?v=1774904864', settings: { top: -26.7, left: 9, scale: 106 }}
        }
    },
    
    // 5. Afro avec volume
    { 
        id: 'afro_volume', 
        name: 'Afro volume',
        icon_url: '',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_volume_blonde.png?v=1774902219', settings: { top: -28.8, left: -1.5, scale: 104 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_volume_brun.png?v=1774902166', settings: { top: -28.8, left: -1.5, scale: 104 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_volume_noir.png?v=1774902101', settings: { top: -28.8, left: -1.5, scale: 104 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_volume_roux.png?v=1774902189', settings: { top: -28.8, left: -1.5, scale: 104 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_volume_rose.png?v=1774902206', settings: { top: -28.8, left: -1.5, scale: 104 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_volume_bleu.png?v=1774902139', settings: { top: -28.8, left: -1.5, scale: 104 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_volume_violet.png?v=1774902120', settings: { top: -28.8, left: -1.5, scale: 104 }}
        }
    },
    
    // 6. Afro simple
    { 
        id: 'afro_simple', 
        name: 'Afro simple',
        icon_url: '',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_Fille_blonde.png?v=1774474861', settings: { top: -37.7, left: -6.7, scale: 104 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_Fille_brun.png?v=1774474898', settings: { top: -37.7, left: -6.7, scale: 104 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_Fille_noir.png?v=1774474847', settings: { top: -37.7, left: -6.7, scale: 104 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_Fille_roux.png?v=1774474832', settings: { top: -37.7, left: -6.7, scale: 104 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_Fille_rose.png?v=1774474882', settings: { top: -37.7, left: -6.7, scale: 104 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_Fille_bleu.png?v=1774474815', settings: { top: -37.7, left: -6.7, scale: 104 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Afro_Fille_violet.png?v=1774474800', settings: { top: -37.7, left: -6.7, scale: 104 }}
        }
    },
    
    // 7. Double couette
    { 
        id: 'double_couette', 
        name: 'Double couette',
        icon_url: '',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Couette_Fille_blonde.png?v=1774903042', settings: { top: -37.4, left: -3.4, scale: 105 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Couette_Fille_brun.png?v=1774903057', settings: { top: -37.4, left: -3.4, scale: 105 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Couette_Fille_noir.png?v=1774903026', settings: { top: -37.4, left: -3.4, scale: 105 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Couette_Fille_roux.png?v=1774903072', settings: { top: -37.4, left: -3.4, scale: 105 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Couette_Fille_rose.png?v=1774903086', settings: { top: -37.4, left: -3.4, scale: 105 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Couette_Fille_bleu.png?v=1774902998', settings: { top: -37.4, left: -3.4, scale: 105 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Couette_Fille_violet.png?v=1774903012', settings: { top: -37.4, left: -3.4, scale: 105 }}
        }
    },
    
    // 8. Cheveux courts
    { 
        id: 'court', 
        name: 'Cheveux courts',
        icon_url: '',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Court_Fille_blonde.png?v=1774903139', settings: { top: -30.8, left: -3.4, scale: 103 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Court_Fille_brun.png?v=1774903119', settings: { top: -30.8, left: -3.4, scale: 103 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Court_Fille_noir.png?v=1774903205', settings: { top: -30.8, left: -3.4, scale: 103 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Court_Fille_roux.png?v=1774903156', settings: { top: -30.8, left: -3.4, scale: 103 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Court_Fille_rose.png?v=1774903218', settings: { top: -30.8, left: -3.4, scale: 103 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/court_Fille_bleu.png?v=1774903101', settings: { top: -30.8, left: -3.4, scale: 103 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Court_Fille_violet.png?v=1774903172', settings: { top: -30.8, left: -3.4, scale: 103 }}
        }
    },
    
    // 9. Cheveux mi-long
    { 
        id: 'mi_long', 
        name: 'Cheveux mi-long',
        icon_url: '',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Mi_long_blonde.png?v=1774903403', settings: { top: -23.9, left: 0.3, scale: 102 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Mi_long_brun.png?v=1774903418', settings: { top: -23.9, left: 0.3, scale: 102 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Mi_long_noir.png?v=1774903368', settings: { top: -23.9, left: 0.3, scale: 102 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Mi_long_roux.png?v=1774903496', settings: { top: -23.9, left: 0.3, scale: 102 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Mi_long_rose.png?v=1774903456', settings: { top: -23.9, left: 0.3, scale: 102 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Mi_long_bleu.png?v=1774903387', settings: { top: -23.9, left: 0.3, scale: 102 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Mi_long_violet.png?v=1774903474', settings: { top: -23.9, left: 0.3, scale: 102 }}
        }
    },
    
    // 10. Cheveux ondulés
    { 
        id: 'ondule', 
        name: 'Cheveux ondulés',
        icon_url: '',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Ondule_Fille_blonde.png?v=1774903580', settings: { top: -16.7, left: 0.1, scale: 102 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Ondule_Fille_brun.png?v=1774903547', settings: { top: -16.7, left: 0.1, scale: 102 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Ondule_Fille_noir.png?v=1774903531', settings: { top: -16.7, left: 0.1, scale: 102 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Ondule_Fille_roux.png?v=1774903618', settings: { top: -16.7, left: 0.1, scale: 102 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Ondule_Fille_rose.png?v=1774903564', settings: { top: -16.7, left: 0.1, scale: 102 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Ondule_Fille_bleu.png?v=1774903515', settings: { top: -16.7, left: 0.1, scale: 102 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Ondule_Fille_violet.png?v=1774903596', settings: { top: -16.7, left: 0.1, scale: 102 }}
        }
    },
    
    // 11. Tresse
    { 
        id: 'tresse', 
        name: 'Tresse',
        icon_url: '',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/resse_Fille_blonde.png?v=1774903730', settings: { top: -13.4, left: -0.8, scale: 101 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/resse_Fille_brun.png?v=1774903714', settings: { top: -13.4, left: -0.8, scale: 101 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/resse_Fille_noir.png?v=1774903700', settings: { top: -13.4, left: -0.8, scale: 101 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/resse_Fille_roux.png?v=1774903669', settings: { top: -13.4, left: -0.8, scale: 101 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/resse_Fille_rose.png?v=1774903684', settings: { top: -13.4, left: -0.8, scale: 101 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/resse_Fille_bleu.png?v=1774903650', settings: { top: -13.4, left: -0.8, scale: 101 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Tresse_Fille_violet.png?v=1774903745', settings: { top: -13.4, left: -0.8, scale: 101 }}
        }
    },
    
    // 12. Twist
    { 
        id: 'twist', 
        name: 'Twist',
        icon_url: '',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Twist_Fille_blonde.png?v=1774903855', settings: { top: -30.1, left: 0.9, scale: 107 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Twist_Fille_brun.png?v=1774903809', settings: { top: -30.1, left: 0.9, scale: 107 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Twist_Fille_noir.png?v=1774903777', settings: { top: -30.1, left: 0.9, scale: 107 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Twist_Fille_roux.png?v=1774903793', settings: { top: -30.1, left: 0.9, scale: 107 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Twist_Fille_rose.png?v=1774903839', settings: { top: -30.1, left: 0.9, scale: 107 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Twist_Fille_bleu.png?v=1774903763', settings: { top: -30.1, left: 0.9, scale: 107 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Twist_Fille_violet.png?v=1774903823', settings: { top: -30.1, left: 0.9, scale: 107 }}
        }
    }
];

const GLASSES_OPTIONS = [
    { id: 'none', name: 'Aucune', icon: '🚫', url: null },
    { id: 'rectangle', name: 'Rectangle', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/lunetterectangle.png?v=1773505066', settings: { top: -25.9, left: -2.6, scale: 103 } },
    { id: 'round', name: 'Rondes', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/lunettes_rondes.png?v=1773505272', settings: { top: -25, left: 1, scale: 105 } }
];

const GLASSES_OPTIONS_GIRL = [
    { id: 'none', name: 'Aucune', icon: '🚫', url: null },
    { id: 'rectangle', name: 'Rectangle', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/lunetterectangle.png?v=1773505066', settings: { top: -25.9, left: -2.6, scale: 103 } },
    { id: 'round', name: 'Rondes', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/lunettes_rondes.png?v=1773505272', settings: { top: -25, left: 1, scale: 105 } }
];

const ACCESSORIES_OPTIONS = [
    { id: 'none', name: 'Aucun', icon: '🚫', url: null },
    { id: 'bonnet', name: 'Bonnet', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Bonnet_bleu.png?v=1773593921', settings: { top: -36.2, left: -4.7, scale: 102 } },
    { id: 'casquette_endroit', name: 'Casquette →', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Casquette_a_l_endroit_bleu.png?v=1773593870', settings: { top: -37.9, left: -0.9, scale: 105 } },
    { id: 'casquette_envers', name: 'Casquette ←', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Casquette_a_l_envers_bleu.png?v=1773593883', settings: { top: -37.4, left: 1.1, scale: 103 } },
    { id: 'chechia1', name: 'Chechia 1', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Takke_blanc.png?v=1773593908', settings: { top: -38.6, left: -1.1, scale: 104 } },
    { id: 'chechia2', name: 'Chechia 2', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Takke_2_blanc.png?v=1773593896', settings: { top: -37.5, left: -0.4, scale: 102 } }
];

const ACCESSORIES_OPTIONS_GIRL = [
    { id: 'none', name: 'Aucun', icon: '🚫', url: null },
    { id: 'bonnet', name: 'Bonnet', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Bonnet_bleu.png?v=1773593921', settings: { top: -37.2, left: -4.7, scale: 115 } },
    { id: 'casquette_endroit', name: 'Casquette →', url: '', settings: { top: -37.9, left: -0.9, scale: 105 } },
    { id: 'casquette_envers', name: 'Casquette ←', url: '', settings: { top: -37.4, left: 1.1, scale: 103 } },
    { id: 'chechia1', name: 'Chechia 1', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/voile_beige.png?v=1775241163', settings: { top: -23.3, left: -1.1, scale: 104 } },
    { id: 'chechia2', name: 'Chechia 2', url: '', settings: { top: -37.5, left: -0.4, scale: 102 } }
];

const EYEBROWS_OPTIONS = [
    { 
        id: 'sourcil1', 
        name: 'Sourcil 1',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Sourcil_blond.png?v=1772930656', settings: { top: -8.4, left: -1.3, scale: 54 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Sourcil_brun.png?v=1772930606', settings: { top: -8.4, left: -1.3, scale: 54 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Sourcil_noir.png?v=1772930589', settings: { top: -8.4, left: -1.3, scale: 54 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Sourcil_roux.png?v=1772930644', settings: { top: -8.4, left: -1.3, scale: 54 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Sourcil_rose.png?v=1772930668', settings: { top: -8.4, left: -1.3, scale: 54 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/sourcil_bleu.png?v=1772966984', settings: { top: -8.4, left: -1.3, scale: 54 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Sourcil_violet.png?v=1772930631', settings: { top: -8.4, left: -1.3, scale: 54 }}
        }
    }
];

const EYEBROWS_OPTIONS_GIRL = [
    { 
        id: 'sourcil1', 
        name: 'Sourcil 1',
        colors: { 
            blond: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Soucille_fille_blond.png?v=1774995451', settings: { top: -10.8, left: -1.4, scale: 70 }},
            brun: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Soucille_fille_brun.png?v=1774995608', settings: { top: -10.8, left: -1.4, scale: 70 }},
            noir: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Soucille_fille_noir.png?v=1774995438', settings: { top: -10.8, left: -1.4, scale: 70 }},
            roux: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Soucille_fille_roux.png?v=1774995584', settings: { top: -10.8, left: -1.4, scale: 70 }},
            rose: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Sourcil_fille_rose.png?v=1774995623', settings: { top: -10.8, left: -1.4, scale: 70 }},
            bleu: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Soucille_fille_bleu.png?v=1774995533', settings: { top: -10.8, left: -1.4, scale: 70 }},
            violet: { url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Soucille_fille_violet.png?v=1774995423', settings: { top: -10.8, left: -1.4, scale: 70 }}
        }
    }
];

const SKIN_TONES = [
    { id: 'blanc', name: 'Blanc', color: '#FFE0BD', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/PersoBlanc.png?v=1773292747' },
    { id: 'bronze', name: 'Bronzé', color: '#E0B896', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/PersoCreme.png?v=1773292941' },
    { id: 'bronze2', name: 'Bronzé+', color: '#D4A574', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/PersoBronze.png?v=1773293301' },
    { id: 'marron', name: 'Marron', color: '#A67C52', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/PersoBrownclaire.png?v=1773293353' },
    { id: 'marron2', name: 'Marron+', color: '#8D5524', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/PersoBrown.png?v=1773293411' }
];

const SKIN_TONES_GIRL = [
    { id: 'blanc', name: 'Blanc', color: '#FFE0BD', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Personnage_Blanc_F.png?v=1773943533' },
    { id: 'bronze', name: 'Bronzé', color: '#E0B896', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Personnage_creme_F.png?v=1773943791' },
    { id: 'bronze2', name: 'Bronzé+', color: '#D4A574', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Personnage_bronze_F.png?v=1773942298' },
    { id: 'marron', name: 'Marron', color: '#A67C52', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Personnage_marron_claire_F.png?v=1773943483' },
    { id: 'marron2', name: 'Marron+', color: '#8D5524', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Personnage_marron_F.png?v=1773943645' }
];

const FRECKLES_OPTIONS = [
    { id: 'none', name: 'Aucune', icon: '🚫', url: null },
    { id: 'freckles', name: 'Taches de rousseur', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Taches_de_rousseurs.png?v=1773499255', settings: { top: -23.5, left: -1.3, scale: 66 } }
];

const EYES_OPTIONS = [
    { id: 'bleu', name: 'Bleu', color: '#4A90E2', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_bleu.png?v=1773057237', settings: { top: -26, left: -1.4, scale: 54 }},
    { id: 'vert', name: 'Vert', color: '#50C878', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_vert_claire.png?v=1773057128', settings: { top: -26, left: -1.1, scale: 54 }},
    { id: 'vert_kaki', name: 'Vert Kaki', color: '#6B8E23', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_vert_kaki.png?v=1773057170', settings: { top: -26, left: -1.3, scale: 54 }},
    { id: 'noisette', name: 'Noisette', color: '#B87333', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_noisette.png?v=1773057143', settings: { top: -26, left: -1.3, scale: 54 }},
    { id: 'marron', name: 'Marron', color: '#8B4513', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_marron.png?v=1773057270', settings: { top: -26, left: -1.4, scale: 54 }},
    { id: 'marron_fonce', name: 'Marron Foncé', color: '#5C4033', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_marron_fonce.png?v=1773057189', settings: { top: -26, left: -1, scale: 54 }},
    { id: 'gris', name: 'Gris', color: '#808080', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_gris.png?v=1773057155', settings: { top: -26, left: -1.3, scale: 54 }},
    { id: 'heterochromie1', name: 'Hétérochromie 1', color: '#A0522D', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_bleu_marron.png?v=1773057252', settings: { top: -26, left: -1.3, scale: 54 }},
    { id: 'heterochromie2', name: 'Hétérochromie 2', color: '#CD853F', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_bleu_vert.png?v=1773057217', settings: { top: -26, left: -1.3, scale: 54 }}
];

const EYES_OPTIONS_GIRL = [
    { id: 'bleu', name: 'Bleu', color: '#4A90E2', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_bleu.png?v=1773057237', settings: { top: -26, left: -1.4, scale: 54 }},
    { id: 'vert', name: 'Vert', color: '#50C878', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_vert_claire.png?v=1773057128', settings: { top: -26, left: -1.1, scale: 54 }},
    { id: 'vert_kaki', name: 'Vert Kaki', color: '#6B8E23', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_vert_kaki.png?v=1773057170', settings: { top: -26, left: -1.3, scale: 54 }},
    { id: 'noisette', name: 'Noisette', color: '#B87333', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_noisette.png?v=1773057143', settings: { top: -26, left: -1.3, scale: 54 }},
    { id: 'marron', name: 'Marron', color: '#8B4513', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_marron.png?v=1773057270', settings: { top: -26, left: -1.4, scale: 54 }},
    { id: 'marron_fonce', name: 'Marron Foncé', color: '#5C4033', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_marron_fonce.png?v=1773057189', settings: { top: -26, left: -1, scale: 54 }},
    { id: 'gris', name: 'Gris', color: '#808080', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_gris.png?v=1773057155', settings: { top: -26, left: -1.3, scale: 54 }},
    { id: 'heterochromie1', name: 'Hétérochromie 1', color: '#A0522D', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_bleu_marron.png?v=1773057252', settings: { top: -26, left: -1.3, scale: 54 }},
    { id: 'heterochromie2', name: 'Hétérochromie 2', color: '#CD853F', url: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/yeux_bleu_vert.png?v=1773057217', settings: { top: -26, left: -1.3, scale: 54 }}
];

const HAIR_COLORS = [
    { id: 'blond', name: 'Blond', color: '#F5DEB3' },
    { id: 'brun', name: 'Brun', color: '#8B5A3C' },
    { id: 'noir', name: 'Noir', color: '#2A2A2A' },
    { id: 'roux', name: 'Roux', color: '#D2691E' },
    { id: 'rose', name: 'Rose', color: '#FFC0CB' },
    { id: 'bleu', name: 'Bleu', color: '#4169E1' },
    { id: 'violet', name: 'Violet', color: '#8B00FF' }
];

const EYES_COLORS = [
    { id: 'heterochromie', name: 'Hétérochromie', color: '#A0522D' },
    { id: 'gris', name: 'Gris', color: '#808080' },
    { id: 'marron', name: 'Marron', color: '#8B4513' },
    { id: 'noir', name: 'Noir', color: '#2A2A2A' },
    { id: 'vert', name: 'Vert', color: '#50C878' },
    { id: 'bleu', name: 'Bleu', color: '#4A90E2' }
];

const BASE_IMAGES = {
    base_boy: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/PersoBlanc.png?v=1773292747',
    base_girl: 'https://cdn.shopify.com/s/files/1/0912/5953/5739/files/Personnage_Blanc_F.png?v=1773943533'
};

const PRODUCT_VARIANTS = {
    rigide: {
        '20x20 cm': {
            withSecondary: '56053136490875',
            withoutSecondary: '56081319231867',
            priceWith: '41,90',
            priceWithout: '39,90'
        }
    },
    souple: {
        '20x20 cm': {
            withSecondary: '56053132624251',
            withoutSecondary: '56081319264635',
            priceWith: '29,90',
            priceWithout: '27,90'
        },
        '14x14 cm': {
            withSecondary: '56070231196027',
            withoutSecondary: '56081319330171',
            priceWith: '21,90',
            priceWithout: '19,90'
        }
    },
    agrafe: {
        '21x21 cm': {
            withSecondary: '56053132657019',
            withoutSecondary: '56081319297403',
            priceWith: '31,90',
            priceWithout: '29,90'
        },
        '14.8x14.8 cm': {
            withSecondary: '56070231228795',
            withoutSecondary: '56081319362939',
            priceWith: '23,90',
            priceWithout: '21,90'
        }
    }
};


// ========================================
// GÉNÉRATION D'IMAGE AVEC ACCÈS DIRECT AUX DATA
// ========================================

// ✅ IDENTIFIANTS CLOUDINARY
const CLOUDINARY_CLOUD_NAME = 'daevhiitx';
const CLOUDINARY_UPLOAD_PRESET = 'livre_perso';

// Stocker les URLs
window.characterImageUrls = {
    personnage1: null,
    personnage2: null
};

// Helper pour charger une image
function loadImageFromUrl(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
    });
}

// Fonction de génération avec accès direct aux variables du configurateur
// Parser la matrice de transformation CSS
function parseMatrix(matrixString) {
    if (!matrixString || matrixString === 'none') {
        return { scaleX: 1, scaleY: 1, translateX: 0, translateY: 0 };
    }
    
    const values = matrixString.match(/matrix.*\((.+)\)/);
    if (!values) return { scaleX: 1, scaleY: 1, translateX: 0, translateY: 0 };
    
    const parts = values[1].split(',').map(v => parseFloat(v.trim()));
    
    return {
        scaleX: parts[0],
        scaleY: parts[3],
        translateX: parts[4] || 0,
        translateY: parts[5] || 0
    };
}

// Fonction de génération - LIT LES STYLES CALCULÉS DU NAVIGATEUR
async function genererImageAvecData(isSecondary = false) {
    console.log('📸 Génération avec styles calculés -', isSecondary ? 'Personnage 2' : 'Personnage 1');
    
    const suffix = isSecondary ? '2' : '';
    
    // Trouver le bon container en cherchant celui qui contient le bon baseLayer
    const baseLayerId = `base${suffix}Layer`;
    const baseLayerEl = document.getElementById(baseLayerId);
    
    if (!baseLayerEl) {
        console.error('❌ baseLayer non trouvé:', baseLayerId);
        return null;
    }
    
    // Remonter jusqu'au container .character-canvas
    let container = baseLayerEl.parentElement;
    while (container && !container.classList.contains('character-canvas')) {
        container = container.parentElement;
    }
    
    if (!container) {
        console.error('❌ Container non trouvé');
        return null;
    }
    
    console.log('✅ Container trouvé pour', baseLayerId);
    
    const containerRect = container.getBoundingClientRect();
    console.log('Container:', containerRect.width, 'x', containerRect.height);
    
    // Liste des calques dans l'ordre
    const layerIds = [
        `base${suffix}Layer`,
        `skin${suffix}Layer`,
        `freckles${suffix}Layer`,
        `eyes${suffix}Layer`,
        `eyebrows${suffix}Layer`,
        `hair${suffix}Layer`,
        `glasses${suffix}Layer`,
        `accessories${suffix}Layer`
    ];
    
    const layers = [];
    
    for (const id of layerIds) {
        const el = document.getElementById(id);
        if (!el || !el.src || el.style.display === 'none') continue;
        
        // LIRE LES STYLES CALCULÉS DU NAVIGATEUR
        const computed = window.getComputedStyle(el);
        const rect = el.getBoundingClientRect();
        
        // Position relative au container
        const x = rect.left - containerRect.left;
        const y = rect.top - containerRect.top;
        
        // Récupérer la transformation
        const transform = parseMatrix(computed.transform);
        
        layers.push({
            id: id,
            url: el.src,
            x: x,
            y: y,
            displayWidth: rect.width,
            displayHeight: rect.height,
            naturalWidth: el.naturalWidth,
            naturalHeight: el.naturalHeight,
            transform: transform
        });
        
        console.log(`${id}:`, {
            x: x.toFixed(1),
            y: y.toFixed(1),
            display: `${rect.width.toFixed(1)}x${rect.height.toFixed(1)}`,
            natural: `${el.naturalWidth}x${el.naturalHeight}`,
            scale: `${transform.scaleX.toFixed(3)}x${transform.scaleY.toFixed(3)}`
        });
    }
    
    if (layers.length === 0) {
        console.error('❌ Aucun calque');
        return null;
    }
    
    console.log('✅', layers.length, 'calques trouvés');
    
    // Charger toutes les images
    const loadedLayers = [];
    
    for (const layer of layers) {
        try {
            const img = await loadImageFromUrl(layer.url);
            
            loadedLayers.push({
                id: layer.id,
                img: img,
                x: layer.x,
                y: layer.y,
                width: layer.displayWidth,
                height: layer.displayHeight
            });
            
        } catch (err) {
            console.warn('⚠️ Erreur:', layer.id, err);
        }
    }
    
    // Trouver les bounds
    let minX = 0, minY = 0, maxX = containerRect.width, maxY = containerRect.height;
    
    loadedLayers.forEach(l => {
        minX = Math.min(minX, l.x);
        minY = Math.min(minY, l.y);
        maxX = Math.max(maxX, l.x + l.width);
        maxY = Math.max(maxY, l.y + l.height);
    });
    
    const canvasWidth = Math.ceil(maxX - minX);
    const canvasHeight = Math.ceil(maxY - minY);
    
    console.log('📐 Canvas:', canvasWidth, 'x', canvasHeight, '| Offset:', minX.toFixed(1), minY.toFixed(1));
    
    // Créer le canvas
    const canvas = document.createElement('canvas');
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    const ctx = canvas.getContext('2d');
    
    // Fond blanc
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, canvasWidth, canvasHeight);
    
    // Dessiner tous les calques SANS déformation
    loadedLayers.forEach(l => {
        // Calculer le scale depuis les dimensions affichées vs naturelles
        const scaleX = l.width / l.img.naturalWidth;
        const scaleY = l.height / l.img.naturalHeight;
        
        // UTILISER UN SCALE UNIFORME - prendre la moyenne ou le min
        const scale = Math.min(scaleX, scaleY);
        
        // Calculer les nouvelles dimensions avec scale uniforme
        const finalWidth = l.img.naturalWidth * scale;
        const finalHeight = l.img.naturalHeight * scale;
        
        // Centrer si besoin
        const offsetX = (l.width - finalWidth) / 2;
        const offsetY = (l.height - finalHeight) / 2;
        
        // Dessiner avec scale uniforme
        ctx.drawImage(
            l.img, 
            l.x - minX + offsetX, 
            l.y - minY + offsetY, 
            finalWidth, 
            finalHeight
        );
        
        console.log('✅', l.id, 'dessiné (scale uniforme:', scale.toFixed(3), ')');
    });
    
    console.log('✅ Tous les calques dessinés');
    
    // Convertir en blob
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png', 0.95));
    console.log('✅ Blob:', (blob.size / 1024).toFixed(2), 'KB');
    
    // Upload Cloudinary
    const formData = new FormData();
    formData.append('file', blob);
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
    
    console.log('📤 Upload...');
    
    const response = await fetch(`https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`, {
        method: 'POST',
        body: formData
    });
    
    const data = await response.json();
    
    if (data.secure_url) {
        console.log('✅ URL:', data.secure_url);
        return data.secure_url;
    } else {
        console.error('❌ Erreur:', data);
        return null;
    }
}

// Fonctions exposées
async function capturePersonnage1() {
    console.log('🎯 Capture personnage 1');
    const url = await genererImageAvecData(false);
    if (url) {
        window.characterImageUrls.personnage1 = url;
        console.log('✅ URL stockée');
    }
}

async function capturePersonnage2() {
    console.log('🎯 Capture personnage 2');
    const url = await genererImageAvecData(true);
    if (url) {
        window.characterImageUrls.personnage2 = url;
        console.log('✅ URL stockée');
    }
}

window.capturePersonnage1 = capturePersonnage1;
window.capturePersonnage2 = capturePersonnage2;

console.log('✅ Génération d\'image intégrée dans DATA');